import React, {useEffect, useRef, useState} from "react";
import {
    XBrowseProps,
    XLazyColumn,
    XLazyDataTable, XLazyDataTableRef,
    XSearchBrowseProps
} from "@michalrakus/x-react-web-lib/XLazyDataTable";
import {Utils} from "../../Utils";
import {KlientSluzbaForm} from "./KlientSluzbaForm";
import {HladatKlientaMimoSluzbuDialog, HladatKlientaMimoSluzbuDialogState} from "./HladatKlientaMimoSluzbuDialog";
import {Klient} from "../../model/klient/klient.entity";
import {OperationType, XUtils} from "@michalrakus/x-react-web-lib/XUtils";
import {xLocaleOption} from "@michalrakus/x-react-web-lib/XLocale";
import {KlientSluzba} from "../../model/klient/klient-sluzba.entity";
import {ColumnBodyOptions} from "primereact/column";
import {XUtilsCommon} from "@michalrakus/x-react-web-lib/XUtilsCommon";
import {XOnSaveOrCancelProp} from "@michalrakus/x-react-web-lib/XFormBase";
import {SluzbaEnum, StatusVSluzbe} from "../../common/enums";
import {XCustomFilter} from "@michalrakus/x-react-web-lib/FindParam";
import {XExpansionSwitch, XExpansionStateType} from "../zapisy/XExpansionSwitch";
import {useXStateSession} from "@michalrakus/x-react-web-lib/useXStateSession";
import {KlientSluzbaOdkazanost} from "../../model/klient/klient-sluzba-odkazanost.entity";

export const KlientSluzbaPoradenstvoBrowse = (props: XBrowseProps & XSearchBrowseProps) => {

    const xLazyDataTableRef = useRef<XLazyDataTableRef>(null);

    const [hladatKlientaDialogState, setHladatKlientaDialogState] = useState<HladatKlientaMimoSluzbuDialogState>({opened: false});

    const sluzbaEnum: SluzbaEnum | undefined = Utils.getCurrentSluzba()?.kod as SluzbaEnum;

    const expansionSwitchValueInit: XExpansionStateType = "expanded";
    const [expansionSwitchValue, setExpansionSwitchValue] = useXStateSession<XExpansionStateType>(`klient-sluzba-poradenstvo-browse-${sluzbaEnum}-expansion-switch-value`, expansionSwitchValueInit);

    useEffect(() => {
        xLazyDataTableRef.current?.setupExpandedRows();
    }, [expansionSwitchValue]);

    const today: Date = XUtilsCommon.today();

    const onSaveOrCancel: XOnSaveOrCancelProp = XUtils.onSaveOrCancelNavigator(props.openForm!, xLazyDataTableRef);

    const onAddRow = () => {

        if (Utils.klientiNezdielani()) {
            if (!Utils.getCurrentSluzba()) {
                alert("Vyberte najprv službu.");
                return;
            }
        }

        if (Utils.zakladneUdajeZdielane()) {
            setHladatKlientaDialogState({
                opened: true,
                onHideDialog: onHideDialog
            });
        }
        else {
            // vsetky udaje zdielane alebo ziadne udaje nezdielane
            openFormNovyKlient();
        }
    }

    const onHideDialog = async (ok: boolean, klient?: Klient | null, objectChange?: OperationType) => {
        // TODO - objectChange nie je spraveny, zatial nepouzivat
        setHladatKlientaDialogState({opened: false});
        if (ok) {
            if (klient !== null) {
                // TODO - zatial vezmeme priamo cely zaznam Klient a pouzijeme ho vo formulari KlientSluzbaForm pre update
                // -> korektnejsie by bolo teraz rereadnut zaznam z DB (pouzit klient!.id)
                // potrebujeme najoinovat vsetko co sa pouziva vo formulari KlientSluzbaForm v casti klient (cast KlientSluzba bude insertovana) (v autocomplete zobrazujeme aj obec aj okres)
                const klientFromDB: Klient = await XUtils.fetchById("Klient", ["pohlavie.name", "obec.okres.nazov", "stat.nazov", "klientSluzbaList.sluzba.nazov"], klient!.id);
                // otvorime formular KlientForm v rezime na insert (id zaznamu KlientSluzba je undefined) a predplnime niektore atributy
                props.openForm!(<KlientSluzbaForm initValues={{klient: klientFromDB, sluzba: Utils.getCurrentSluzba(), version: 0}} onSaveOrCancel={onSaveOrCancel}/>);
            }
            else {
                openFormNovyKlient();
            }
        }
    }

    const openFormNovyKlient = () => {
        // otvorime formular KlientForm v rezime na insert, pricom aj klient bude nanovo vytvoreny
        // inicializacia prebehne cez KlientSluzbaForm.createNewObject()
        props.openForm!(<KlientSluzbaForm onSaveOrCancel={onSaveOrCancel}/>);
    }

    const onEdit = (selectedRow: any) => {
        // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu
        props.openForm!(<KlientSluzbaForm id={selectedRow.id} onSaveOrCancel={onSaveOrCancel}/>);
    }

    const onRemoveRow = async (selectedRow: any): Promise<boolean> =>  {
        if (window.confirm(xLocaleOption('removeRowConfirm'))) {
            await XUtils.post('remove-klient-sluzba', {id: selectedRow.id});
            return true;
        }
        return false;
    }

    const rowClassName = (rowData: KlientSluzba): (string | object | undefined) => {
        // zosnulych a neaktivnych nezobrazujeme ale zakaz moze byt zobrazeny
        let rowClassNameMap: {[field: string]: boolean} = {
            'zapis-hlavny-riadok': expansionSwitchValue === 'expanded'
            //'klient-sluzba-zosnuly': Utils.klientSluzbaZosnuly(rowData),
            //'klient-sluzba-neaktivny': Utils.klientSluzbaNeaktivnyOrNieJeKlient(rowData)
        };
        const typZakazuClassName: string | undefined = Utils.klientSluzbaZistiTypZakazuClassName(Utils.klientSluzbaZistiTypZakazu(rowData, today));
        if (typZakazuClassName) {
            rowClassNameMap[typZakazuClassName] = true;
        }
        return rowClassNameMap;
    };

    const odkazanostBody = (klientSluzba: KlientSluzba, options: ColumnBodyOptions): React.ReactNode => {
        if (!klientSluzba.klientSluzbaOdkazanostList || klientSluzba.klientSluzbaOdkazanostList.length === 0) {
            return null;
        }
        const klientSluzbaOdkazanostList: KlientSluzbaOdkazanost[] = XUtilsCommon.arraySort(klientSluzba.klientSluzbaOdkazanostList, "id");
        const odkazanostValues: string = klientSluzbaOdkazanostList
            .map(klientSluzbaOdkazanost => klientSluzbaOdkazanost.odkazanost.name + (klientSluzbaOdkazanost.stupenOdkazanosti ? " - " + klientSluzbaOdkazanost.stupenOdkazanosti?.name : ""))
            .join('\n');
        return <div style={{whiteSpace: 'pre-line'}}>{odkazanostValues}</div>;
    }

    const cielBody = (klientSluzba: KlientSluzba, options: ColumnBodyOptions): React.ReactNode => {
        if (!klientSluzba.klientSluzbaCielSpolupraceList || klientSluzba.klientSluzbaCielSpolupraceList.length === 0) {
            return null;
        }
        const cielValues = klientSluzba.klientSluzbaCielSpolupraceList
            .filter(item => item.datumDo === null && item.ciel !== null && item.ciel.trim() !== '')
            .map(item => item.ciel)
            .join('\n');
        return <div style={{whiteSpace: 'pre-line'}}>{cielValues || null}</div>;
    }

    const ciastkoveCieleBody = (klientSluzba: KlientSluzba, options: ColumnBodyOptions): React.ReactNode => {
        if (!klientSluzba.klientSluzbaCielSpolupraceList || klientSluzba.klientSluzbaCielSpolupraceList.length === 0) {
            return null;
        }
        const ciastkoveCieleValues = klientSluzba.klientSluzbaCielSpolupraceList
            .filter(item => item.datumDo === null && item.ciastkoveCiele !== null && item.ciastkoveCiele.trim() !== '')
            .map(item => item.ciastkoveCiele)
            .join('\n');
        return <div style={{whiteSpace: 'pre-line'}}>{ciastkoveCieleValues || null}</div>;
    }

    const showExpandedRow = (klientSluzba: KlientSluzba): boolean => {
        return expansionSwitchValue === "expanded" &&
            ((klientSluzba.klientSluzbaCielSpolupraceList &&
               klientSluzba.klientSluzbaCielSpolupraceList.length > 0 &&
               klientSluzba.klientSluzbaCielSpolupraceList.some(item => item.datumDo === null && (item.ciel !== null && item.ciel.trim() !== '' || item.ciastkoveCiele !== null && item.ciastkoveCiele.trim() !== '')))
            || (klientSluzba.klientSluzbaOdkazanostList &&
                    klientSluzba.klientSluzbaOdkazanostList.length > 0));
    };

    const rowExpansionTemplate = (klientSluzba: KlientSluzba) => {
        const activeItems = klientSluzba.klientSluzbaCielSpolupraceList
            ?.filter(item => item.datumDo === null && (item.ciel !== null && item.ciel.trim() !== '' || item.ciastkoveCiele !== null && item.ciastkoveCiele.trim() !== ''))
            || [];

        let odkazanost: React.ReactNode = null;
        if (klientSluzba.klientSluzbaOdkazanostList
            && klientSluzba.klientSluzbaOdkazanostList.length > 0) {
            const klientSluzbaOdkazanostList: KlientSluzbaOdkazanost[] = XUtilsCommon.arraySort(klientSluzba.klientSluzbaOdkazanostList, "id");
            const odkazanostValues: string = klientSluzbaOdkazanostList
                .map(klientSluzbaOdkazanost => klientSluzbaOdkazanost.odkazanost.name + (klientSluzbaOdkazanost.stupenOdkazanosti ? " - stupeň " + klientSluzbaOdkazanost.stupenOdkazanosti?.name : ""))
                .join('\n');
            odkazanost =
                <div style={{display: 'flex', flexDirection: 'row', padding: '0.5rem'}}>
                    <div>Odkázanosť:</div><div style={{whiteSpace: 'pre-line', paddingLeft: '1rem'}}>{odkazanostValues}</div>
                </div>;
        }

        if (activeItems.length === 0 && odkazanost === null) {
            return null;
        }

        return (
            <div className="x-multiline-content">
                {odkazanost}
                <table style={{width: '100%', borderCollapse: 'collapse'}}>
                    <tbody>
                        {activeItems.map((item, index) => (
                            <tr key={item.id || index}>
                                <td style={{padding: '0.5rem', verticalAlign: 'top', whiteSpace: 'pre-line'}}>
                                    {item.ciel || ''}
                                </td>
                                <td style={{padding: '0.5rem', verticalAlign: 'top', whiteSpace: 'pre-line'}}>
                                    {item.ciastkoveCiele || ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    // iba aktivnych klientov zobrazime
    let customFilter: XCustomFilter | undefined = {where: `[statusVSluzbe.code] = '${StatusVSluzbe.aktivnyKlient}'`, params: {}};
    if (Utils.klientiNezdielani()) {
        customFilter = XUtilsCommon.filterAnd(customFilter, Utils.filterCurrentSluzba());
    }

    let potrebyColumnWidth: number = XUtils.toPX0("15rem");
    let temyColumnWidth: number = XUtils.toPX0("15rem");
    // pridame sirku "zrusenych" stlpcov ak mame zapnuty expand
    if (expansionSwitchValue === "expanded") {
        const columnWidthToAdd: number = (XUtils.toPX0("13rem") + XUtils.toPX0("15rem") + XUtils.toPX0("45rem")) / 2; // stlpce ciel a ciastkoveCiele
        potrebyColumnWidth += columnWidthToAdd;
        temyColumnWidth += columnWidthToAdd;
    }

    return (
        <div>
            <XLazyDataTable ref={xLazyDataTableRef} entity="KlientSluzba" stateKey={`klient-sluzba-poradenstvo-browse-${sluzbaEnum}`}
                            label="Klienti - individuálne poradenstvo" sortField="id desc" rows={30} customFilter={customFilter}
                            onAddRow={onAddRow} onEdit={onEdit} removeRow={onRemoveRow}
                            fields={["klientSluzbaZakazList.id", "statusVSluzbe.code", "klientSluzbaCielSpolupraceList.ciel",
                                "klientSluzbaOdkazanostList.odkazanost.name", "klientSluzbaOdkazanostList.stupenOdkazanosti.name"]}
                            assocsToSort={[{assoc: "klientSluzbaCielSpolupraceList", sortField: "id"}]}
                            rowClassName={rowClassName}
                            showExpandedRow={showExpandedRow}
                            rowExpansionTemplate={rowExpansionTemplate}
                            headerBodyRight={<XExpansionSwitch value={expansionSwitchValue} onChange={(switchValue: XExpansionStateType) => {setExpansionSwitchValue(switchValue);}} className="m-1"/>}
                            searchBrowseParams={props.searchBrowseParams}>
                <XLazyColumn field="klient.menoPriezviskoPrezyvka" header="Meno priezvisko prezývka" width="14rem" className="klient-meno"/>
                <XLazyColumn field="klucovyPracovnikXUser.name" header="Kľúčový pracovník" width="11rem"
                             autoComplete={Utils.userColumnAutoComplete("klucovyPracovnikXUser")} autoFilter={true}/>
                <XLazyColumn field="klientSluzbaOdkazanostList.odkazanost.name" header="Odkázanosť" body={odkazanostBody} contentType="multiline" width="13rem"
                             columnViewStatus={expansionSwitchValue === "colapsed"}/>
                <XLazyColumn field="klientSluzbaCielSpolupraceList.ciel" header="Individuálny plán - ciele" body={cielBody} contentType="multiline" width="15rem"
                             columnViewStatus={expansionSwitchValue === "colapsed"}/>
                <XLazyColumn field="klientSluzbaCielSpolupraceList.ciastkoveCiele" header="Čiastkové ciele" body={ciastkoveCieleBody} contentType="multiline" width="45rem"
                             columnViewStatus={expansionSwitchValue === "colapsed"}/>
                <XLazyColumn field="potrebyOcakavaniaKlienta" header="Potreby očakávania klienta" contentType="multiline" width={`${potrebyColumnWidth}px`}/>
                <XLazyColumn field="temyNaRozhovor" header="Témy na rozhovor" contentType="multiline" width={`${temyColumnWidth}px`}/>
            </XLazyDataTable>
            <HladatKlientaMimoSluzbuDialog dialogState={hladatKlientaDialogState}/>
        </div>
    );
}

